import { Component } from '@angular/core';

@Component({
  templateUrl: './add-edit-product.page.html',
})
/**
 * Component class for the Add/Edit Product page.
 */
export class AddEditProductPage {}
